if (!customElements.get('attentive-form')) {
  const AttentiveForm = class extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.attentive-form-container');
      this.statusContainer = this.querySelector('.form-status');
      this.form = this.querySelector('form');
      this.formURL = this.form.getAttribute('action');
      
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      // this.form.querySelectorAll('input:not([type="checkbox"])');
      this.form.querySelectorAll('input:not([type="checkbox"])').forEach(e => {
        e.addEventListener('focus', this.handleConsent.bind(this))
        // if(e.closest('.form-field').querySelector('.agreement-block') != undefined){
        //   e.closest('.form-field').querySelector('.agreement-block').classList.add('hidden');
        // }
      })
    }

    async handleSubmit(evt){
      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.querySelector('.form-status').innerHTML = ``;

      function getUTMParams() {
        return {
          utm_source: localStorage.getItem('utm_source') || '',
          utm_medium: localStorage.getItem('utm_medium') || '',
          utm_campaign: localStorage.getItem('utm_campaign') || ''
        };
      }
      const formData = new URLSearchParams();
      if(this.form.querySelector('[name="list_id_attentive"]') != undefined){
        formData.append('list_id', this.form.querySelector('[name="list_id_attentive"]').value);
      }
      formData.append('email', this.form.querySelector('[name="email"]').value);
      formData.append('phone', this.form.querySelector('[name="phone_number"]').value);

      const customAttributes = getUTMParams();
      formData.append('customAttributes', JSON.stringify(customAttributes));

      if (!this.validate()) return;

      try {
        const response = await fetch(
          this.formURL,
          {
            method: "POST",
            body: formData
          }
        );
        console.log(response);

        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}`);
        }

        const result = await response.json();
        if(result.ok == true){
        this.querySelector('.form-status').innerHTML = `<p class="success">You’re on the list.</p>`;
        console.log(result);
        }

        if(result.error == true){
          this.querySelector('.form-status').innerHTML = `<p class="error">${result.messages[0]}</p>`;
        }else{

        //   this.querySelector('.form-status').innerHTML = `<p class="success">You’re on the list.</p>`;
        //   this.form.reset();
        //    setTimeout(() => {
        //   this.querySelector('.form-status').innerHTML = '';
        // }, 5000);

          this.querySelector('.form-status').innerHTML = `<p class="success">You’re on the list.</p>`;

          const email = this.form.querySelector('[name="email"]').value;
          const phone = this.form.querySelector('[name="phone_number"]').value;

          // if(email){
          //   window.ElevarDataLayer.push({
          //     event: "dl_subscribe",
          //     lead_type: "email",
          //     user_properties: { customer_email: email }
          //   });
          // }

          // if(phone){
          //   window.ElevarDataLayer.push({
          //     event: "dl_subscribe",
          //     lead_type: "phone",
          //     user_properties: { customer_phone: phone }
          //   });
          // }

          this.form.reset();

          setTimeout(() => {
            this.querySelector('.form-status').innerHTML = '';
          }, 5000);
        //}

        }
        
      } catch (error) {
        console.error(error);
      }
    }
    
    validate(){
      let valid = true;
      if(this.form.querySelector('.agreement-block') != undefined){
        this.form.querySelectorAll('.agreement-block').forEach(el => {
          if(el.querySelector('[type="checkbox"]').checked != true){
            this.querySelector('.form-status').innerHTML = `<p class="error">Please accept the terms.</p>`;
            valid = false;
          }
        })
      }
      return valid;
    }

    handleConsent(evt){
      if(evt.target.closest('.form-field').querySelector('.agreement-block') != undefined){
        evt.target.closest('.form-field').querySelector('.agreement-block').classList.remove('hidden');
      }
    }
  }
  window.customElements.define('attentive-form', AttentiveForm);
}